module.exports = __webpack_public_path__ + "assets/cd14d12b4af1dfa77829be4a6ddc423e.mp4";